var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngineerAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 850.39 850.39",
    viewBox: "0 0 850.39 850.39",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\u5716\u5C64_1",
    display: "none"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\u5716\u5C64_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m439.43 771.26c.41 7.88 8.83 15.77 0 23.65 0-7.88 0-15.77 0-23.65z",
    fill: "#e0dfe4"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m442.32 216.77c4.78 4.78 20.29 12.14 27.52 15.43 1.45.66 1.45 2.71 0 3.37-7.23 3.29-22.74 10.65-27.52 15.43s-12.14 20.29-15.43 27.52c-.66 1.45-2.71 1.45-3.37 0-3.29-7.23-10.65-22.74-15.43-27.52s-20.29-12.14-27.52-15.43c-1.45-.66-1.45-2.71 0-3.37 7.23-3.29 22.74-10.65 27.52-15.43s12.14-20.29 15.43-27.52c.66-1.45 2.71-1.45 3.37 0 3.28 7.23 10.65 22.74 15.43 27.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m442.32 342.99c4.78 4.78 20.29 12.14 27.52 15.43 1.45.66 1.45 2.71 0 3.37-7.23 3.29-22.74 10.65-27.52 15.43s-12.14 20.29-15.43 27.52c-.66 1.45-2.71 1.45-3.37 0-3.29-7.23-10.65-22.74-15.43-27.52s-20.29-12.14-27.52-15.43c-1.45-.66-1.45-2.71 0-3.37 7.23-3.29 22.74-10.65 27.52-15.43s12.14-20.29 15.43-27.52c.66-1.45 2.71-1.45 3.37 0 3.28 7.23 10.65 22.74 15.43 27.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m442.32 469.2c4.78 4.78 20.29 12.14 27.52 15.43 1.45.66 1.45 2.71 0 3.37-7.23 3.29-22.74 10.65-27.52 15.43s-12.14 20.29-15.43 27.52c-.66 1.45-2.71 1.45-3.37 0-3.29-7.23-10.65-22.74-15.43-27.52s-20.29-12.14-27.52-15.43c-1.45-.66-1.45-2.71 0-3.37 7.23-3.29 22.74-10.65 27.52-15.43s12.14-20.29 15.43-27.52c.66-1.45 2.71-1.45 3.37 0 3.28 7.24 10.65 22.75 15.43 27.52z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m425.2 735.62c-5.2 0-10.39-1.25-15.13-3.76l-166.01-87.89c-10.61-5.62-17.21-16.57-17.21-28.58v-485.62c0-8.28 6.72-15 15-15h366.7c8.28 0 15 6.72 15 15v485.62c0 12.01-6.59 22.96-17.21 28.58l-166.01 87.89c-4.74 2.51-9.94 3.76-15.13 3.76zm-168.35-590.85v470.62c0 .87.48 1.66 1.24 2.07l166.01 87.89c.69.36 1.5.36 2.19 0l166.01-87.89c.77-.41 1.24-1.2 1.24-2.07v-470.62z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineerAvatar);
export default __webpack_public_path__ + "static/media/engineer_avatar.b0160072e3bd6ccaa68ec2481b547148.svg";
export { ForwardRef as ReactComponent };